import Colors, { getColor, AVAILABLE_COLORS } from './colors';

export { getColor, AVAILABLE_COLORS };

export default Colors;
